<template>
  <ul class="footer-errors mb-0">
    <li>
      <div class="errors-slots">
        Errors:
        <mdicon name="Square" class="mx-2" />
        {{ fatalErrorCount }} {{ pluralize('slot', fatalErrorCount) }}
      </div>
    </li>

    <li v-if="false">
      <div class="errors-nav">
        <button class="disabled">
          <mdicon name="ChevronLeft" />
        </button>
        <span class="errors-nav-page">1/4</span>
        <button>
          <mdicon name="ChevronRight" />
        </button>
      </div>
    </li>

    <li>
      <div class="errors-type">
        <p>View type</p>
        <div class="switch-error">
          All
          <ToggleBtn v-model="isErrorsOnly" :value="fatalErrorCount" @change="updateErrorsFilter" />
          Errors only
        </div>
      </div>
    </li>
  </ul>
</template>

<script lang="ts">
import { computed, defineComponent, watch } from 'vue'
import { pluralize } from '@/services/Helpers'
import { useItemStore } from '@/store/item'
import ToggleBtn from '@/views/Components/Elements/Buttons/ToggleBtn.vue'

export default defineComponent({
  name: 'ItemsErrors',
  components: {
    ToggleBtn,
  },
  setup() {
    const itemStore = useItemStore()

    const fatalErrorCount = computed(() => itemStore.fatalErrorsCount)
    const isErrorsOnly = computed(() => itemStore.errorsOnly)

    const updateErrorsFilter = (value: boolean) => {
      itemStore.setErrorsOnly(value)
    }

    watch(fatalErrorCount, (newVal) => {
      if (newVal === 0 && isErrorsOnly.value) {
        updateErrorsFilter(false)
      }
    })

    return {
      pluralize,
      updateErrorsFilter,
      fatalErrorCount,
      isErrorsOnly,
    }
  },
})
</script>
